module.exports = __webpack_public_path__ + "img/证书8.957d5b27.jpg";